import { Dispatch, useReducer } from 'react';

export default function usePartialState<T>(initialState: Partial<T>): readonly [T & Partial<T>, Dispatch<Partial<T>>] {
  const [state, setState] = useReducer(
    (prevState: T, newState: Partial<T>) => ({
      ...prevState,
      ...newState,
    }),
    initialState as T,
  );

  return [state, setState] as const;
}
